export default __webpack_public_path__ + "static/media/fddbr.c974f965.jpg";